import React from "react";
import { zl } from "../../../../functions/utilities";

const ZbiorowyKomornikOpisy = props => {

    const { stawkiInd, saldoStare } = props;

    let indeks = 0;

    const saldoTxt = saldoStare > 0 ? "nadpłata" : "niedopłata";

    const saldo = saldoStare !== 0 && (
        <li>
            <sup style={{verticalAlign: "super", fontSize: "0.8em"}}>{`${1}   `}</sup> 
            {`${zl(saldoStare)} saldo za ${new Date().getFullYear()-1}r. (${saldoTxt})`} 
        </li>
    )

    const indy = stawkiInd?.map( (s, i) => {
        let j = saldoStare !== 0 ? 2 : 1;
        return (
            <li key={i}>
                <sup style={{verticalAlign: "super", fontSize: "0.8em"}}>{`${i+j}   `}</sup> 
                {`${zl(s.kwota)} ${s.opis}`}
            </li>
        )
    });

    return (
        <div style={{
            padding: "40px 0 0 0"
        }}>
            <p style={{margin: "5px 0"}}>
                Legenda:
            </p>
            <ul>
                { saldo }
                { indy }
            </ul>
        </div>
    )
}

export default ZbiorowyKomornikOpisy;